import { createSlice } from "@reduxjs/toolkit"
import {
  addPracticalTrainingParticipant,
  createPracticalTraining,
  deletePracticalTraining,
  deletePracticalTrainingParticipant,
  getAllPracticalTrainings,
  getMatchedPracticalCandidates,
  getPracticalTrainingDetails,
  getPracticalTrainingParticipants,
  markMultiplePracticalTrainingParticipantAttendance,
  markPracticalTrainingParticipantAttendance,
  updatePracticalTraining,
} from "store/actions/practicalTrainingAction"

const practicalTrainingInitialPayload = {
  limit: 50,
  page_number: 1,
  order_by: 1,
  filters: {
    keyword: "",
    date_range: {
      start_date: "",
      end_date: "",
    },
  },
}

const practicalTrainingParticipantsInitialPayload = {
  limit: 50,
  page_number: 1,
  training_uuid: null,
  filters: {
    keyword: "",
    job_title_ids: [],
  },
}

const initialState = {
  loading: false,
  isLoading: false,
  isGettingDetails: false,
  practicalTrainings: [],
  practicalTrainingDetails: {},
  practicalParticipants: [],
  practicalMatchedCandidates: [],
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  payload: practicalTrainingInitialPayload,
  participantsListPayload: practicalTrainingParticipantsInitialPayload,
  isShowFilter: false,
  isMatching: false,
  totalPages1: null,
  currentPage1: null,
  totalCount1: null,
  candidatesMatchedCount: null,
  activeTab: 0,
  attendance_count: 0,
  participants_count: 0,
}

const practicalSlice = createSlice({
  name: "Practical Training",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },
    setParticipantsPayload: (state, action) => {
      state.participantsListPayload = {
        ...state.participantsListPayload,
        ...action.payload,
      }
    },

    resetParticipantsPayload: state => {
      state.participantsListPayload =
        practicalTrainingParticipantsInitialPayload
    },
    resetPayload: state => {
      state.payload = practicalTrainingInitialPayload
    },
    toggleFilterVisibility: state => {
      state.isShowFilter = !state.isShowFilter
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAllPracticalTrainings.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getAllPracticalTrainings.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.practicalTrainings = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getAllPracticalTrainings.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(deletePracticalTraining.pending, state => {
        state.isLoading = true
      })
      .addCase(deletePracticalTraining.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(deletePracticalTraining.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(createPracticalTraining.pending, state => {
        state.isLoading = true
      })
      .addCase(createPracticalTraining.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createPracticalTraining.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updatePracticalTraining.pending, state => {
        state.isLoading = true
      })
      .addCase(updatePracticalTraining.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePracticalTraining.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getPracticalTrainingDetails.pending, state => {
        state.isGettingDetails = true
        state.practicalTrainingDetails = {}
      })
      .addCase(getPracticalTrainingDetails.fulfilled, (state, action) => {
        state.isGettingDetails = false
        const { success, data } = action.payload || {}
        if (success) {
          state.practicalTrainingDetails = data
        }
      })
      .addCase(getPracticalTrainingDetails.rejected, (state, action) => {
        state.isGettingDetails = false
      })

    builder
      .addCase(getPracticalTrainingParticipants.pending, state => {
        // state.loading = true
        state.practicalParticipants = []
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
        state.participants_count = 0
        state.attendance_count = 0
      })
      .addCase(getPracticalTrainingParticipants.fulfilled, (state, action) => {
        // state.loading = false
        const { success, data } = action.payload || {}
        if (success) {
          const {
            total_records,
            current_page,
            total_pages,
            participants_count,
            attendance_count,
          } = action.payload || {}
          state.practicalParticipants = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
          state.participants_count = participants_count || 0
          state.attendance_count = attendance_count || 0
        }
      })
      .addCase(getPracticalTrainingParticipants.rejected, (state, action) => {
        // state.loading = false
      })

    builder
      .addCase(addPracticalTrainingParticipant.pending, state => {
        state.isLoading = true
      })
      .addCase(addPracticalTrainingParticipant.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addPracticalTrainingParticipant.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(markPracticalTrainingParticipantAttendance.pending, state => {
        state.isLoading = true
      })
      .addCase(
        markPracticalTrainingParticipantAttendance.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        markPracticalTrainingParticipantAttendance.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )

    builder
      .addCase(deletePracticalTrainingParticipant.pending, state => {
        state.isLoading = true
      })
      .addCase(
        deletePracticalTrainingParticipant.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(deletePracticalTrainingParticipant.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getMatchedPracticalCandidates.pending, state => {
        state.isMatching = true
        state.practicalMatchedCandidates = []
        state.totalPages1 = null
        state.totalCount1 = null
        state.currentPage1 = null
      })
      .addCase(getMatchedPracticalCandidates.fulfilled, (state, action) => {
        state.isMatching = false
        const { success, data } = action.payload
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.practicalMatchedCandidates = data
          state.totalPages1 = total_pages
          state.totalCount1 = total_records
          state.currentPage1 = current_page
        }
      })
      .addCase(getMatchedPracticalCandidates.rejected, (state, action) => {
        state.isMatching = false
      })

    builder
      .addCase(
        markMultiplePracticalTrainingParticipantAttendance.pending,
        state => {
          state.isLoading = true
        }
      )
      .addCase(
        markMultiplePracticalTrainingParticipantAttendance.fulfilled,
        (state, action) => {
          state.isLoading = false
        }
      )
      .addCase(
        markMultiplePracticalTrainingParticipantAttendance.rejected,
        (state, action) => {
          state.isLoading = false
        }
      )
  },
})

export const {
  setPayload,
  resetPayload,
  toggleFilterVisibility,
  setParticipantsPayload,
  resetParticipantsPayload,
  setActiveTab,
} = practicalSlice.actions
export default practicalSlice.reducer
